<div class="form-textarea">
  <label class="input-title">{{ title | translate }}</label>
  <div class="textarea-container">
    <app-textarea
      #formTextarea
      [id]="id"
      [shouldFocus]="focus"
      [control]="fc(control)"
      [placeholder]="placeholder"
      [mentionData]="mentionData">
    </app-textarea>

    @if (toggleEnabled) {
      <div
        class="toggle-btn clickable tooltip-wrapper"
      [appTooltip]="
        expanded
          ? ('DESCRIPTIONS_FORM.COLLAPSE' | translate)
          : ('DESCRIPTIONS_FORM.EXPAND' | translate)
      "
        tooltipPosition="top"
        (click)="onToggle()">
        <fa-icon [icon]="expanded ? icons.up : icons.down"></fa-icon>
      </div>
    }

    @if (showRemoveButton) {
      <div
        class="cancel-btn clickable tooltip-wrapper"
        [appTooltip]="'DESCRIPTIONS_FORM.REMOVE' | translate"
        tooltipPosition="top"
        (click)="removeDescription()">
        <fa-icon [icon]="icons.cancel"></fa-icon>
      </div>
    }
  </div>
</div>
